"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Proposal = void 0;
var Coins_1 = require("../Coins");
var numeric_1 = require("../numeric");
var json_1 = require("../../util/json");
var proposals_1 = require("../distribution/proposals");
var proposals_2 = require("../params/proposals");
var proposals_3 = require("./proposals");
var proposals_4 = require("../upgrade/proposals");
var gov_1 = require("@terra-money/terra.proto/cosmos/gov/v1beta1/gov");
var Long = __importStar(require("long"));
/**
 * Stores information pertaining to a submitted proposal, such as its status and time of
 * the voting period
 */
var Proposal = /** @class */ (function (_super) {
    __extends(Proposal, _super);
    /**
     *
     * @param id proposal's ID
     * @param content content of the proposal
     * @param status proposal's status
     * @param final_tally_result tally result
     * @param submit_time time proposal was submitted and deposit period started
     * @param deposit_end_time time deposit period will end
     * @param total_deposit amount of coins deposited by all users
     * @param voting_start_time time voting period will start
     * @param voting_end_time time voting period will end
     */
    function Proposal(id, content, status, final_tally_result, submit_time, deposit_end_time, total_deposit, voting_start_time, voting_end_time) {
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.content = content;
        _this.status = status;
        _this.final_tally_result = final_tally_result;
        _this.submit_time = submit_time;
        _this.deposit_end_time = deposit_end_time;
        _this.total_deposit = total_deposit;
        _this.voting_start_time = voting_start_time;
        _this.voting_end_time = voting_end_time;
        return _this;
    }
    Proposal.fromAmino = function (data) {
        var id = data.id, content = data.content, status = data.status, final_tally_result = data.final_tally_result, submit_time = data.submit_time, deposit_end_time = data.deposit_end_time, total_deposit = data.total_deposit, voting_start_time = data.voting_start_time, voting_end_time = data.voting_end_time;
        return new Proposal(Number.parseInt(id), Proposal.Content.fromAmino(content), status, {
            yes: new numeric_1.Int(final_tally_result.yes || 0),
            no: new numeric_1.Int(final_tally_result.no || 0),
            abstain: new numeric_1.Int(final_tally_result.abstain || 0),
            no_with_veto: new numeric_1.Int(final_tally_result.no_with_veto || 0),
        }, new Date(submit_time), new Date(deposit_end_time), Coins_1.Coins.fromAmino(total_deposit), new Date(voting_start_time), new Date(voting_end_time));
    };
    Proposal.prototype.toAmino = function () {
        var _a = this, status = _a.status, final_tally_result = _a.final_tally_result;
        return {
            id: this.id.toFixed(),
            content: this.content.toAmino(),
            status: status,
            final_tally_result: {
                yes: final_tally_result.yes.toFixed(),
                no: final_tally_result.no.toFixed(),
                abstain: final_tally_result.abstain.toFixed(),
                no_with_veto: final_tally_result.no_with_veto.toFixed(),
            },
            submit_time: this.submit_time.toISOString(),
            deposit_end_time: this.deposit_end_time.toISOString(),
            total_deposit: this.total_deposit.toAmino(),
            voting_start_time: this.voting_start_time.toISOString(),
            voting_end_time: this.voting_end_time.toISOString(),
        };
    };
    Proposal.fromData = function (data) {
        var proposal_id = data.proposal_id, content = data.content, status = data.status, final_tally_result = data.final_tally_result, submit_time = data.submit_time, deposit_end_time = data.deposit_end_time, total_deposit = data.total_deposit, voting_start_time = data.voting_start_time, voting_end_time = data.voting_end_time;
        return new Proposal(Number.parseInt(proposal_id), Proposal.Content.fromData(content), (0, gov_1.proposalStatusFromJSON)(status), {
            yes: new numeric_1.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.yes) || 0),
            no: new numeric_1.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.no) || 0),
            abstain: new numeric_1.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.abstain) || 0),
            no_with_veto: new numeric_1.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.no_with_veto) || 0),
        }, new Date(submit_time), new Date(deposit_end_time), Coins_1.Coins.fromData(total_deposit), new Date(voting_start_time), new Date(voting_end_time));
    };
    Proposal.prototype.toData = function () {
        var _a = this, status = _a.status, final_tally_result = _a.final_tally_result;
        return {
            proposal_id: this.id.toFixed(),
            content: this.content.toData(),
            status: (0, gov_1.proposalStatusToJSON)(status),
            final_tally_result: {
                yes: final_tally_result.yes.toString(),
                no: final_tally_result.no.toString(),
                abstain: final_tally_result.abstain.toString(),
                no_with_veto: final_tally_result.no_with_veto.toString(),
            },
            submit_time: this.submit_time.toISOString(),
            deposit_end_time: this.deposit_end_time.toISOString(),
            total_deposit: this.total_deposit.toData(),
            voting_start_time: this.voting_start_time.toISOString(),
            voting_end_time: this.voting_end_time.toISOString(),
        };
    };
    Proposal.fromProto = function (data) {
        var id = data.proposalId;
        var content = data.content;
        var status = data.status;
        var final_tally_result = data.finalTallyResult;
        var submit_time = data.submitTime;
        var deposit_end_time = data.depositEndTime;
        var total_deposit = data.totalDeposit;
        var voting_start_time = data.votingStartTime;
        var voting_end_time = data.votingEndTime;
        return new Proposal(id.toNumber(), Proposal.Content.fromProto(content), status, {
            yes: new numeric_1.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.yes) || 0),
            no: new numeric_1.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.no) || 0),
            abstain: new numeric_1.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.abstain) || 0),
            no_with_veto: new numeric_1.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.noWithVeto) || 0),
        }, submit_time, deposit_end_time, Coins_1.Coins.fromProto(total_deposit), voting_start_time, voting_end_time);
    };
    Proposal.prototype.toProto = function () {
        var _a = this, status = _a.status, final_tally_result = _a.final_tally_result;
        var ftr;
        if (final_tally_result) {
            ftr = gov_1.TallyResult.fromPartial({
                yes: final_tally_result.yes.toString(),
                no: final_tally_result.no.toString(),
                abstain: final_tally_result.abstain.toString(),
                noWithVeto: final_tally_result.no_with_veto.toString(),
            });
        }
        return gov_1.Proposal.fromPartial({
            proposalId: Long.fromNumber(this.id),
            content: this.content.packAny(),
            status: status,
            finalTallyResult: ftr,
            submitTime: this.submit_time,
            depositEndTime: this.deposit_end_time,
            totalDeposit: this.total_deposit.toProto(),
            votingEndTime: this.voting_end_time,
            votingStartTime: this.voting_start_time,
        });
    };
    return Proposal;
}(json_1.JSONSerializable));
exports.Proposal = Proposal;
(function (Proposal) {
    Proposal.Status = gov_1.ProposalStatus;
    var Content;
    (function (Content) {
        function fromAmino(amino) {
            switch (amino.type) {
                case 'gov/TextProposal':
                    return proposals_3.TextProposal.fromAmino(amino);
                case 'distribution/CommunityPoolSpendProposal':
                    return proposals_1.CommunityPoolSpendProposal.fromAmino(amino);
                case 'params/ParameterChangeProposal':
                    return proposals_2.ParameterChangeProposal.fromAmino(amino);
                case 'upgrade/SoftwareUpgradeProposal':
                    return proposals_4.SoftwareUpgradeProposal.fromAmino(amino);
                case 'upgrade/CancelSoftwareUpgradeProposal':
                    return proposals_4.CancelSoftwareUpgradeProposal.fromAmino(amino);
            }
        }
        Content.fromAmino = fromAmino;
        function fromData(data) {
            switch (data['@type']) {
                case '/cosmos.gov.v1beta1.TextProposal':
                    return proposals_3.TextProposal.fromData(data);
                case '/cosmos.distribution.v1beta1.CommunityPoolSpendProposal':
                    return proposals_1.CommunityPoolSpendProposal.fromData(data);
                case '/cosmos.params.v1beta1.ParameterChangeProposal':
                    return proposals_2.ParameterChangeProposal.fromData(data);
                case '/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal':
                    return proposals_4.SoftwareUpgradeProposal.fromData(data);
                case '/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal':
                    return proposals_4.CancelSoftwareUpgradeProposal.fromData(data);
            }
        }
        Content.fromData = fromData;
        function fromProto(anyProto) {
            var typeUrl = anyProto.typeUrl;
            switch (typeUrl) {
                case '/cosmos.gov.v1beta1.TextProposal':
                    return proposals_3.TextProposal.unpackAny(anyProto);
                case '/cosmos.distribution.v1beta1.CommunityPoolSpendProposal':
                    return proposals_1.CommunityPoolSpendProposal.unpackAny(anyProto);
                case '/cosmos.params.v1beta1.ParameterChangeProposal':
                    return proposals_2.ParameterChangeProposal.unpackAny(anyProto);
                case '/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal':
                    return proposals_4.SoftwareUpgradeProposal.unpackAny(anyProto);
                case '/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal':
                    return proposals_4.CancelSoftwareUpgradeProposal.unpackAny(anyProto);
            }
            throw "Proposal content " + typeUrl + " not recognized";
        }
        Content.fromProto = fromProto;
    })(Content = Proposal.Content || (Proposal.Content = {}));
})(Proposal = exports.Proposal || (exports.Proposal = {}));
exports.Proposal = Proposal;
//# sourceMappingURL=Proposal.js.map